<div class="background-item-1"></div>
<div class="background-item-2"></div>
<div class="background-item-3"></div>
